import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Locale } from '@api-types/enums/locale.enum';
import { LocaleService } from '@core/services/locale.service';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pm-footer',
  templateUrl: './footer.component.html',
  imports: [TranslateModule],
  host: {
    class: 'mt-auto',
  },
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear();

  private readonly localeService = inject(LocaleService);
  private readonly router = inject(Router);

  openDocumentation(): void {
    if (environment.environment === 'development') {
      this.router.navigate(['/documentation']).catch(() => undefined);
    }
  }

  openPrivacyPolicy(): void {
    const locale = this.localeService.getCurrentUserLocale();
    switch (locale) {
      case Locale.GERMAN:
        this.goToLink('https://www.pacemaker.ai/informationen-zum-datenschutz');
        break;
      case Locale.UK:
      case Locale.US:
      default:
        this.goToLink(
          'https://www.pacemaker.ai/en/data-protection-information',
        );
        break;
    }
  }

  openImprint(): void {
    const locale = this.localeService.getCurrentUserLocale();
    switch (locale) {
      case Locale.GERMAN:
        this.goToLink('https://www.pacemaker.ai/impressum');

        break;
      case Locale.UK:
      case Locale.US:
      default:
        this.goToLink('https://www.pacemaker.ai/en/imprint');
        break;
    }
  }

  goToLink(url: string): void {
    window.open(url, 'noopener');
  }

  getVersion() {
    return environment.version;
  }

  getEnvType() {
    return environment.environment;
  }
}
